import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { path_file } from '@app/config/path-file.enum';
import { DOC_ORIENTATION, NgxImageCompressService } from 'ngx-image-compress';
import { Storage, ref, getDownloadURL, uploadBytesResumable, UploadTask } from '@angular/fire/storage'

declare var $: any;

@Component({
  selector: 'input-image-cropper',
  templateUrl: './input-image-cropper.component.html',
  styleUrls: ['./input-image-cropper.component.css']
})
export class InputImageCropperComponent implements OnInit {

  @Input() id: string = '';
  @Input() control: UntypedFormControl;
  @Input() type: string = '';
  @Input() title: string = '';
  @Input() placeholder: string = '';
  @Input() messageRequired: string = '';
  @Output() eventSelectFile = new EventEmitter<EventSelectFile>();

  public format: string = ".jpg, jpeg, .png";
  public classImage: string = '';
  public inProgress: boolean = false;
  public progressPercentaje: number = 0;
  public fileName: string = '';
  public urlImage: string = '';
  private pathFile: string = '';

  @ViewChild('inputFile', { static: false }) inputFile: ElementRef;


  constructor(private imageCompress: NgxImageCompressService, private storage: Storage, private cd: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.control.valueChanges.subscribe(() => {
      this.setPhotoValue(this.control.value)
    })

    switch (this.type) {

      case 'inputEmployeePhoto':
        this.pathFile = path_file.UserPhoto;
        break;

      case 'inputEmployerPhoto':
        this.pathFile = path_file.UserPhoto;
        this.classImage = 'img-file-upload-center';
        break;

      case 'inputEmployerProfileHeader':
        this.pathFile = path_file.EmployerPhoto;
        break;


      case 'inputEmployerPrincipalPhoto':
        this.pathFile = path_file.EmployerPrincipal;
        break;

      case 'inputEmployerMemberPhoto':
        this.pathFile = path_file.EmployerPrincipal;
        break;

      case 'inputEmployerTeacherPhoto':
        this.pathFile = path_file.EmployerTeacher;
        break;

    }
  }

  onClickPseudoBtn(event: PointerEvent): void {
    event.preventDefault();
    this.openSelectFile();
  }

  onSelectFile(event) {

    if (event.target.files && event.target.files[0]) {

      this.eventSelectFile.next({
        event,
        name: event.target.files[0].name || 'Eliminar'
      })
    }
  }

  reset() {
    this.inProgress = false;
    this.progressPercentaje = 0;
    this.urlImage = '';
    this.fileName = '';
  }

  onUploadPhoto(event: EventUploadPhotoCropped) {
    this.inProgress = true;
    this.progressPercentaje = 0;

    this.imageCompress.compressFile(event.croppedPhoto, DOC_ORIENTATION.Up).then(
      result => {
        this.calculateProgressTask(this.uploadPhoto(result, Date.now().toString().concat('-', event.name), this.pathFile), event.name)
      }
    )

    /*  if (this.modalParentName && this.modalParentName !== undefined) {
        $("#" + this.modalParentName).modal('show');
      }
    */
  }






  setPhotoValue(url: string) {

    if (!url) { return }

    this.urlImage = url;

    try {
      this.setFileValue(url.split('/').pop().split('#')[0].split('?')[0]);
    }
    catch
    {
      this.setFileValue("Eliminar");
    }
  }

  setFileValue(fileName: string) {

    if (!fileName) { return; }

    var ix = fileName.indexOf("-");

    var file = fileName;

    if (ix >= 0) {
      file = fileName.slice(ix + 1, fileName.length);
    }

    this.fileName = file === "" ? 'Eliminar' : file;
  }

  calculateProgressTask(
    uploadTask: UploadTask,
    fileName: string) {
    uploadTask.on('state_changed',
      (snapshot) => {
        this.progressPercentaje = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
      },
      () => {

        this.inProgress = false;
        this.removeFile();
        this.cd.detectChanges();
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then(url => {

          this.inProgress = false;
          this.fileName = fileName;
          this.urlImage = url;
          this.control.setValue(url);
          this.cd.detectChanges();
        });
      })
  }

  removeFile() {
    $(`#${this.id}`).val('');
    this.fileName = '';
    this.urlImage = '';
    this.control.setValue('');
    this.cd.detectChanges();
  }

  uploadPhoto(filestr: string, _id: any, path: any) {
    const refStorage = ref(this.storage, path + _id);
    return uploadBytesResumable(refStorage, this.dataURItoBlob(filestr));
  }

  dataURItoBlob(dataURI: string) {

    // convert base64 to raw binary data held in a string
    // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
    var byteString = atob(dataURI.split(',')[1]);

    // separate out the mime component
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

    // write the bytes of the string to an ArrayBuffer
    var ab = new ArrayBuffer(byteString.length);

    // create a view into the buffer
    var ia = new Uint8Array(ab);

    // set the bytes of the buffer to the correct values
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    // write the ArrayBuffer to a blob, and you're done
    var blob = new Blob([ab], { type: mimeString });
    return blob;

  }

  openSelectFile() {
    this.inputFile.nativeElement.value = "";
    $(`#${this.id}`).click();
  }


}
